module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Links importantes")]), (_vm.isLoading) ? _c('loading') : (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay links importantes ingresados")])])]) : _vm._e(), _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "p-10 pt-20"
  }, [_c('ol', _vm._l((_vm.lista), function(o, index) {
    return _c('li', {
      staticClass: "cursor-pointer text-left transition-quick mb-8"
    }, [_c('a', {
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(o.descripcion))])])
  }), 0)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5156c56","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Links_Importantes.vue
// module id = 958
// module chunks = 0